import { homeSEOContent } from '@/mocks/seoContent';

export default function FeatureGrid() {
  const { howItWorks } = homeSEOContent;

  return (
    <section id="how-it-works" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-xs font-semibold text-foreground-400 uppercase tracking-widest mb-3">How It Works</p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight max-w-2xl">
            Seamless Browsing,<br />Instant Redirects
          </h2>
          <p className="mt-4 text-sm text-foreground-500 max-w-lg">
            Three simple steps to access thousands of verified CSSBuy product finds — no registration, no fees, just instant access.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {howItWorks.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-xl p-7 border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-5">
                <i className={`${item.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}